import {useAtom} from "jotai/index";
import {CommentConversationAtom, SelectedConversationAtom} from "../atoms";
import Modal from "@mui/material/Modal";
import {Button, Stack, TextField, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import {ConversationRepository} from "../../../../repositories/ConversationRepository";
import {toast} from "react-toastify";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: "sm", width: "90%",
  maxHeight: "50dvh",
  bgcolor: 'background.paper',
  borderRadius: 2,
  border: '0px solid #000',
  boxShadow: 24,
  p: 3,
  overflowY: "auto"
};

export const ConversationComment = () => {
  const [selectedConversation, setSelectedConversation] = useAtom(SelectedConversationAtom);
  const [open, setOpen] = useAtom(CommentConversationAtom);
  const [comment, setComment] = useState("");

  useEffect(() => {
    setComment(open && selectedConversation ? selectedConversation.comment : "");
  }, [open, selectedConversation]);

  const handleSave = () => {
    ConversationRepository.commentConversation({id: selectedConversation?.id, comment: comment})
      .then(response => {
        setSelectedConversation(prev => response?.data || prev);
        handleClose();
      })
      .catch((error) => {
        toast.error("Failed to leave comment");
      })
  }

  const handleClose = () => {
    setOpen(false);
  }

  return (
    <Modal
      open={!!open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Stack direction={"column"} gap={2} sx={style}>
        <Stack direction={"row"} gap={2} alignItems={"center"}>
          <Typography variant={"h4"} fontWeight={600}>Leave Comment</Typography>
        </Stack>
        <TextField
          placeholder={"Please enter comment here"}
          multiline minRows={3} maxrows={6}
          value={comment} onChange={e => setComment(e.target.value)}
        />
        <Stack direction={"row"} gap={2} alignItems={"center"} sx={{mt: "auto"}}>
          <Button
            onClick={handleClose}
            sx={{borderRadius: 2, flex: 1}}
            variant={"ghost"} color={"secondary"}
          >
            Close
          </Button>
          <Button
            variant={"modal"} color={"secondary"}
            onClick={handleSave}
            sx={{borderRadius: 2, flex: 1}}
          >
            Save
          </Button>
        </Stack>
      </Stack>
    </Modal>
  )
}